import * as React from 'react';
import {FACompsBySeasonDate, FAComps} from '@nls-2022/nls-bll';
import {Select} from './BlogFormInputs';
export type BlogPostSelectRoundPropsType = {
  handleCompChange: any;
  selectedSeason: string;
  selectedComp: string | undefined | null;
};

// /* export const Select = ({
//   register,
//   name,
//   options,
//   defaultValue,
//   ...rest
// }: any) => {
//   return (
//     <select defaultValue={defaultValue} {...register(name)} {...rest}>
//       {options.map((option: string, index: string) => (
//         <option value={option} key={index}>
//           {option}
//         </option>
//       ))}
//     </select>
//   );
// }; */

const BlogPostSelectCompBaseV2 = ({
  register,
  selectedSeason,
  setValue,
  selectedComp,
}: any) => {
  let compDataforSeason = FACompsBySeasonDate.find(
    (u: {season: any}): boolean => {
      return u.season === selectedSeason;
    },
  );
  React.useEffect(() => {
    //setValue('Round', '');
  }, [selectedSeason, setValue, selectedComp]);
  if (selectedComp === null) {
    return <></>;
  }
  let compDetails: Array<string> | undefined = FAComps.map(
    (i: {name: any}) => i.name,
  );

  return (
    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Competition
      </label>
      <Select
        name="Comp"
        register={register}
        options={compDetails}
        defaultValue={selectedComp}
      />
    </div>
  );
};
export default BlogPostSelectCompBaseV2;
